import React, { Fragment, useContext, useState, useEffect, useRef } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import CommonModal from '../../common/modal';
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from 'react-router-dom';
import { pinagareAPIURL } from '../../../../../Constant';
import { trackPromise } from 'react-promise-tracker';
import PromiseSpinner from '../../../../../CommonElements/Spinner/PromiseSpinner';
import { Breadcrumbs, Btn, H6, H5, P } from '../../../../../AbstractElements';

const FormModal = ({ isChairSecretary,isApprovingStageSupervisor,userDetails,scheme_application_id,modal, NewMessage, toggle, defaultVal, PSorOther, closeBtnTxt, saveBtnTxt,approverType,rejectBtnTxt}) =>{

  const [supervisor_feedback, setSupervisorFeedback] = useState('');
  const [what_to_do_with, setWhat_to_do_with] = useState('');
  const history = useNavigate();

  const initialValues = { what_to_do_with: "",supervisor_feedback:"",applicant_hard_to_replace:"",replacement_staff_available:"",applicant_in_critical_assignment:""};
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isPsSubmit, setIsPsSubmit] = useState(false);
  const [submitButtonName, setsubmitButtonName] = useState("");
  const [submitButtonValue, setButtonValue] = useState("");
  const [isApplicantCritical, setIsApplicantCritical] = useState(false);


  const myToggle = (event) => {
    event.preventDefault();
    setFormErrors({});
    toggle();
  }

  const supervisorFeedbackHandler = (event) => {

    const { name, value } = event.target;
    setSupervisorFeedback(event.target.value);
    setFormValues({ ...formValues, [name]: value });
  }

  const setWhat_to_do_withHandler = (event) => {
    //setWhat_to_do_with(event.target.value);
    const { name, value } = event.target;
    
    //alert(event.target.name+"--"+event.target.value);

      let parame=event.target.name;
         if (formErrors[parame]!=undefined&&formErrors[parame]!=null){
          delete formErrors[parame];
          setFormErrors(formErrors);
         } 
    
    if(event.target.name=="application_verified"){//e.target.checked
      

      if(event.target.checked){
        setFormValues({ ...formValues, [name]: value });
      }
      else{
        setFormValues({ ...formValues, [name]: "" });
      }

      }
      else if(event.target.name=="applicant_in_critical_assignment"){

        if(event.target.value=='yes'){
          setIsApplicantCritical(true);
        }
        else{
          setIsApplicantCritical(false);
        }
        setFormValues({ ...formValues, [name]: value });
      }
      else {
       setFormValues({ ...formValues, [name]: value });
     }
  }
  
  const submitFeedbackHandler = (event) => {
    event.preventDefault();//alert(event.target.name+"--"+event.target.value);

    setIsPsSubmit(true);
    //setFormValues(initialValues);
    setsubmitButtonName(event.target.name);
    setButtonValue(event.target.value);

    setFormErrors(validate(formValues,event.target.name));//alert(event.target.name+"-Other-"+event.target.value);
    
    
/*if(isApprovingStageSupervisor && userDetails.stage!=1 && !PSorOther){
    trackPromise(
       submitSupervisorReview(formValues.supervisor_feedback,'',event.target.name,event.target.value,'',formValues.award_amount)
    );
  }*/
   
  }

  const handlePsSubmit = (event) => {//alert("t "+formValues.what_to_do_with)
    event.preventDefault();
     setIsPsSubmit(true);
    //setFormValues(initialValues);
    setsubmitButtonName(event.target.name);
    setButtonValue(event.target.value);
    setFormErrors(validate(formValues,event.target.name));//alert(event.target.name+"-PS-"+event.target.value);
   
  };

  useEffect(() => {
   
   
    if (Object.keys(formErrors).length === 0 && isPsSubmit) {
      //console.log("Submitted successfully: "+JSON.stringify(formValues));
      

      if(formValues.what_to_do_with!=='' && PSorOther && isApprovingStageSupervisor){//alert('sending...');
      
        trackPromise(
           submitSupervisorReview(formValues.supervisor_feedback,formValues.what_to_do_with,submitButtonName,submitButtonValue,"","",formValues)
          ); 
          
        //setFormErrors({});
        //setFormValues(initialValues);
      }
      else if(formValues.application_verified!=='' && userDetails.stage==1 && isApprovingStageSupervisor){//alert('sending...2');
      
        trackPromise(
           submitSupervisorReview(formValues.supervisor_feedback,"",submitButtonName,submitButtonValue,formValues.application_verified,"",formValues)
          ); 
          
        //setFormErrors({});
        //setFormValues(initialValues);
      }
      else if(isApprovingStageSupervisor && userDetails.stage!=1 && !PSorOther){
        trackPromise(
           submitSupervisorReview(formValues.supervisor_feedback,'',submitButtonName,submitButtonValue,'',formValues.award_amount,formValues)
        );
      }
      else{
        //alert("y "+formValues.application_verified);
      }
        
      

    }else {
      
      if (Object.keys(formErrors).length > 0 && isPsSubmit) {
          toast.error("Please fill all the required fields. There are errors in your form.");
      }
    }
  }, [formErrors]);


  const validate = (values,btn_name) => {
    const errors = {};//   
   
    if (PSorOther) {

    if (!values.what_to_do_with) {
      errors.what_to_do_with = "You must specify what should be done with the position incase the Evaluation Board approves the application.";
    }

    if (!values.applicant_in_critical_assignment) {
      errors.applicant_in_critical_assignment = "You must indicate whether the applicant is currently involved in a critical assignment that could be jeopardized if he/she is released.";
    }

    if (!values.applicant_hard_to_replace) {
      errors.applicant_hard_to_replace = "You must indicate whether you believe this applicant will be hard to replace if he/she is released";
    }

    if (!values.replacement_staff_available) {
      errors.replacement_staff_available = "You must specify whether or not qualified replacement staff is available to fill this position incase the applicant is released.";
    }
//alert(values.applicant_in_critical_assignment);
    if (!values.supervisor_feedback && values.applicant_in_critical_assignment!=undefined&&values.applicant_in_critical_assignment=="yes") {
      errors.supervisor_feedback = "You must provide a summary of the critical assignment that the applicant is involved in.";
    }

  }
    
    if (!values.application_verified && userDetails.stage==1 ) {
      errors.application_verified = "You must confirm that you have checked the completeness of this application.";
    }

    if (!values.award_amount && btn_name =="endorse_button" && (isChairSecretary.isChairperson||isChairSecretary.isSecretary) ) {
      errors.award_amount = "You must enter the amount awarded to this candidate.";
    }
//alert("submitButtonName- "+submitButtonName+" submitButtonValue- "+submitButtonValue);
          
    return errors;

  };

 
  async function submitSupervisorReview(supervisor_feedback,what_to_do_with,button_name,button_value,application_verified,award_amount,thisFormValues) {
    try {
      await fetch(pinagareAPIURL, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          omang: localStorage.getItem('username'),
          //applicant_omang: applicant_omang,
          supervisor_feedbck: supervisor_feedback,
          what_to_do_with_position: what_to_do_with,
          scheme_application_id: scheme_application_id,
          button_name: button_name,
          button_value: button_value,
          approver_type:approverType,
          award_amount:award_amount,
          application_verified:application_verified,
          eng:'submit_supervisor_feedback', 
          applicant_in_critical_assignment: formValues.applicant_in_critical_assignment,
          applicant_hard_to_replace: formValues.applicant_hard_to_replace,
          replacement_staff_available:formValues.replacement_staff_available,          
        }),
      })
        .then((respose) => {
          if (respose.ok) {
            //console.log('hh8 -- '+JSON.stringify(respose))
            return respose.json()
          }
          else{
          throw new Error('error')
          }
        })
        .then((data) => {
          //console.log('gg8 -- '+JSON.stringify(data))
          if (data.status) {

            //localStorage.setItem('username_temp', data.username);
            //navigate('/')
            
            //setUsernameExists(true);
            toast.success("Application Reviewed Successfully!");
            //toggle();
            history(`${process.env.PUBLIC_URL}/dpsm/supervisor-tasks`);
          } else {
            
            //set error
            //console.log('err8 -- ');
            //toast.error("An error occurred!..5");
          }
          setIsPsSubmit(false);
        })
    } catch (error) {
      //console.log(JSON.stringify(error));
      toast.error("Oops...An error occurred!6");
      setIsPsSubmit(false);
    }
  }

    return(
      <CommonModal setFormErrors={setFormErrors} approverType={approverType}  PSorOther={PSorOther} submitFeedbackHandler={PSorOther ||userDetails.stage==1 ? handlePsSubmit : submitFeedbackHandler} isOpen={modal} title={NewMessage } toggler={myToggle} closeBtnTxt={closeBtnTxt} saveBtnTxt={saveBtnTxt} rejectBtnTxt={rejectBtnTxt}>
        <Form >
          
		  { PSorOther ? (<span><FormGroup>
                        <Label className="col-form-label" for="what_to_do_with"><H6>{"What should happen to the position?:"}</H6></Label>
                        <Input type="select" onChange={setWhat_to_do_withHandler} name="what_to_do_with" placeholder="Select Status" className="form-control digits" required >
                            <option value="">{"Select"}</option>
                            <option value="abolish_position">{"Abolish Position"}</option>
                            <option value="suspend_for_a_year">{"Suspend Position for a Year"}</option>
							              <option value="find_replacement">{"Find a Replacement"}</option>
                        </Input>
                        <span style={{ color: 'red' }}>{formErrors.what_to_do_with}</span>
                        
                    </FormGroup>
                    <FormGroup> 
                    <Label><H6>{"Is the applicant currently engaged in any critical assignment/project that would be significantly impacted by their departure from public service?"}</H6></Label>
                      <div className='m-t-15 m-checkbox-inline custom-radio-ml'>
                        <div className='radio radio-primary'>

                          <Input onClick={setWhat_to_do_withHandler} id='applicant_in_critical_assignment_radio1' type='radio' name='applicant_in_critical_assignment' value='yes' />
                          <Label className='mb-0' for='applicant_in_critical_assignment_radio1'>
                             {"Yes"}                  
                          </Label>
                        </div>
                                   
                        <div className='radio radio-primary'>
                          <Input onClick={setWhat_to_do_withHandler} id='applicant_in_critical_assignment_radio2' type='radio' name='applicant_in_critical_assignment' value='no'  />
                          <Label className='mb-0' for='applicant_in_critical_assignment_radio2'>
                            {"No"}                 
                          </Label>
                        </div>
                        <span style={{ color: 'red' }}>{formErrors.applicant_in_critical_assignment}</span>
                      </div>
                    {isApplicantCritical? (<div id="supervisor_feedback_critical_applicant">
                      <hr />
                    <Label className="col-form-label" for="supervisor_feedback">{'If yes, provide details below:'}</Label>
                        
                    <Input type="textarea" onChange={setWhat_to_do_withHandler} name="supervisor_feedback" className="form-control" id="supervisor_feedback"></Input>
                    <span style={{ color: 'red' }}>{formErrors.supervisor_feedback}</span>
                     </div>):null}

                    </FormGroup>

                    <FormGroup>
                    <Label><H6>{"Is it challenging to fill this position or to find a suitable replacement?"}</H6></Label>
                      <div className='m-t-15 m-checkbox-inline custom-radio-ml'>
                        <div className='radio radio-primary'>

                          <Input onClick={setWhat_to_do_withHandler} id='applicant_hard_to_replace_radio1' type='radio' name='applicant_hard_to_replace' value='yes' />
                          <Label className='mb-0' for='applicant_hard_to_replace_radio1'>
                             {"Yes"}                  
                          </Label>
                        </div>
            
                        <div className='radio radio-primary'>
                          <Input onClick={setWhat_to_do_withHandler} id='applicant_hard_to_replace_radio2' type='radio' name='applicant_hard_to_replace' value='no'  />
                          <Label className='mb-0' for='applicant_hard_to_replace_radio2'>
                            {"No"}                 
                          </Label>
                        </div>
                        <span style={{ color: 'red' }}>{formErrors.applicant_hard_to_replace}</span>
                      </div>
      
                    </FormGroup>

                    <FormGroup>
                    <Label><H6>{"Is there adequate internal bench strength, with qualified individuals ready and available to assume the position if it becomes vacant?"}</H6></Label>
                      <div className='m-t-15 m-checkbox-inline custom-radio-ml'>
                        <div className='radio radio-primary'>

                          <Input onClick={setWhat_to_do_withHandler} id='replacement_staff_available_radio1' type='radio' name='replacement_staff_available' value='yes' />
                          <Label className='mb-0' for='replacement_staff_available_radio1'>
                             {"Yes"}                  
                          </Label>
                        </div>
            
                        <div className='radio radio-primary'>
                          <Input onClick={setWhat_to_do_withHandler} id='replacement_staff_available_radio2' type='radio' name='replacement_staff_available' value='no'  />
                          <Label className='mb-0' for='replacement_staff_available_radio2'>
                            {"No"}                 
                          </Label>
                        </div>
                        <span style={{ color: 'red' }}>{formErrors.replacement_staff_available}</span>
                      </div>
      
                    </FormGroup>

                    
                    </span>):
          (<FormGroup>
            <Label className="col-form-label" for="supervisor_feedback">{'Feedback on this application: (Optional)'}</Label>
            <Input type="textarea" onChange={supervisorFeedbackHandler} name="supervisor_feedback" className="form-control" id="supervisor_feedback"></Input>
          </FormGroup>)}

          { isApprovingStageSupervisor && userDetails.stage==1? (  <FormGroup><hr />
                    
                    <div className='m-t-15 m-checkbox-inline custom-radio-ml'>
                        <div className='checkbox checkbox-primary' style={{paddingLeft:'12px'}}>
                            <Input onChange={setWhat_to_do_withHandler} value="I_confirm_that_I_have_verified_this_application" id='application_verified' name='application_verified' type='checkbox' className={'form-control '}  />
                            <label htmlFor="application_verified" className="form-check-label">
                            I confirm that I have verified this application
                           </label>
                                <span style={{ color: 'red' }}>{formErrors.application_verified}</span>
                        </div>
                    </div>
                  
                </FormGroup>) :null}

                {isChairSecretary==null||isChairSecretary==undefined? null: (isChairSecretary.isChairperson||isChairSecretary.isSecretary?(
                  <FormGroup><hr />
                    <Label className="col-form-label" for="award_amount">{'Award Amount (in Pula)'}</Label>
                    <Input type="text" onChange={setWhat_to_do_withHandler} name="award_amount" className="form-control" id="award_amount"></Input>
                    <span style={{ color: 'red' }}>{formErrors.award_amount}</span>
                 </FormGroup>
                ): null ) }
		  
        </Form>
      </CommonModal>     
    
    );
};

export default FormModal;